import moment from 'moment';

export const importDateIsWithinType86EtaWindow = (importDate: string) => {
  const now = moment();
  const eta = moment(importDate);
  const etaMinus7Days = eta.clone().subtract(7, 'days');
  return now.isBetween(etaMinus7Days, eta, 'days', '[]');
};
